import { defineComponent, computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import config from '../../config';
import StocksItem from './stocks-item.vue';
export default defineComponent({
    name: 'stocks',
    components: {
        StocksItem: StocksItem,
    },
    setup: function () {
        // data
        var selected = ref('');
        var companies = ref(config.companies);
        var errors = ref([]);
        var loading = ref(false);
        // getters
        var store = useStore();
        // computed
        var stocks = computed(function () { return store.getters.getStocks; });
        var fetchStocks = function () {
            loading.value = true;
            companies.value.map(function (symbol) {
                store
                    .dispatch('fetchDataStocks', { symbol: symbol })
                    .catch(function (error) { return errors.value.push(error); })
                    .finally(function () { return (loading.value = false); });
            });
        };
        fetchStocks();
        var router = useRouter();
        var openStock = function (item) {
            router.push({
                name: 'page-stock',
                params: { symbol: item.symbol },
            });
        };
        return {
            stocks: stocks,
            selected: selected,
            companies: companies,
            errors: errors,
            loading: loading,
            openStock: openStock,
        };
    },
});
